module.exports = __webpack_public_path__ + "static/media/facebook.c0dc027b.svg";